<template>
  <div v-if="dataUrl" class="qr-container" data-cy="order-qr-code">
    <div class="qr-frame">
      <img :src="dataUrl" :alt="$t('screens.order.qrCodeTitle')" />
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 180,
    },
  },
  data() {
    return {
      dataUrl: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.render();
      },
    },
  },
  methods: {
    async render() {
      if (!this.value) {
        this.dataUrl = null;
        return;
      }

      try {
        this.dataUrl = await QRCode.toDataURL(this.value, {
          width: this.size,
          margin: 1,
          errorCorrectionLevel: 'M',
        });
      } catch (error) {
        console.error('Failed to generate order QR code:', error);
        this.dataUrl = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-container {
  display: flex;
  justify-content: center;
}

// the frame is what carries the radius: the QR image itself is white with
// square corners, so padding must be >= the radius or the curve eats into it
.qr-frame {
  background-color: $color-white;
  border: 1px solid #eeeeee;
  border-radius: 16px;
  padding: 16px;
  line-height: 0;
}
</style>
